// Legacy component - redirects to new PayrollDashboard
import PayrollDashboard from './PayrollDashboard';

const PayrollProcessing = () => {
  return <PayrollDashboard />;
};

export default PayrollProcessing;